// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-charts-insights__icon_critical {
  color: var(--g-color-text-danger);
}
.chartkit-charts-insights__icon_warning {
  color: var(--g-color-text-warning-heavy);
}
.chartkit-charts-insights__icon_info {
  color: var(--g-color-text-info);
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/ChartKitBase/components/Header/components/ChartsInsights/components/ChartsInsightsIcon/ChartsInsightsIcon.scss"],"names":[],"mappings":"AAEQ;EACI,iCAAA;AADZ;AAIQ;EACI,wCAAA;AAFZ;AAKQ;EACI,+BAAA;AAHZ","sourcesContent":[".chartkit-charts-insights__icon_critical {\n  color: var(--g-color-text-danger);\n}\n.chartkit-charts-insights__icon_warning {\n  color: var(--g-color-text-warning-heavy);\n}\n.chartkit-charts-insights__icon_info {\n  color: var(--g-color-text-info);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
